import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import api from "../../core/api/config";
import BotaoSuporte from "../components/BotaoSuporte.jsx";
import Graficos from "../components/Graficos";

const cidadeOrganogramaMap = {
  Aguaí: 1,
  "Águas da Prata": 12,
  Caconde: 39,
  "Casa Branca": 49,
  Divinolândia: 64,
  "Espírito Santo do Pinhal": 73,
  "Estiva Gerbi": 83,
  Itapira: 100,
  Itobi: 119,
  Mococa: 147,
  "Mogi Guaçu": 184,
  "Mogi Mirim": 235,
  "Santa Cruz das Palmeiras": 294,
  "Santo Antônio do Jardim": 299,
  "São João da Boa Vista": 308,
  "São José do Rio Pardo": 311,
  "São Sebastião da Grama": 367,
  Tambaú: 373,
  Tapiratiba: 383,
  "Vargem Grande do Sul": 399,
};

const ChartsDashboard = () => {
  const acessoAtivo = useSelector((state) => state.access.acessoAtivo);

  const [, setOrganogramaSelecionado] = useState(null);
  const [cidadeSelecionada, setCidadeSelecionada] = useState(null);
  const [loading, setLoading] = useState(false);

  const [dadosCards, setDadosCards] = useState({
    total_papa_atrasado: 0,
    total_agendar_primeiro_papa: 0,
    total_mamografia_atrasada: 0,
    total_agendar_primeira_mamografia: 0,
    total_controle_mama: 0,
    total_controle_colo: 0,
  });

  //  FUNÇÃO ÚNICA DE BUSCA (evita duplicação)
  const buscarCards = async (payloadBase) => {
    setLoading(true);

    try {
      const responses = await Promise.all([
        api.post("/api/tracking/cards", {
          ...payloadBase,
          idadeMinima: 25,
          idadeMaxima: 64,
          statusColoId: [1, 2, 4, 5, 7, 8, 9],
        }),
        api.post("/api/tracking/cards", {
          ...payloadBase,
          idadeMinima: 25,
          idadeMaxima: 64,
          statusColoId: [3, 6],
        }),
        api.post("/api/tracking/cards", {
          ...payloadBase,
          idadeMinima: 25,
          idadeMaxima: 64,
          statusColoId: [7],
        }),
        api.post("/api/tracking/cards", {
          ...payloadBase,
          idadeMinima: 50,
          idadeMaxima: 74,
          statusMamaId: [1, 2, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15],
        }),
        api.post("/api/tracking/cards", {
          ...payloadBase,
          idadeMinima: 50,
          idadeMaxima: 74,
          statusMamaId: [3, 4],
        }),
        api.post("/api/tracking/cards", {
          ...payloadBase,
          idadeMinima: 50,
          idadeMaxima: 74,
          statusMamaId: [9],
        }),
      ]);

      setDadosCards({
        total_controle_colo: responses[0].data.total || 0,
        total_agendar_primeiro_papa: responses[1].data.total || 0,
        total_papa_atrasado: responses[2].data.total || 0,
        total_controle_mama: responses[3].data.total || 0,
        total_agendar_primeira_mamografia: responses[4].data.total || 0,
        total_mamografia_atrasada: responses[5].data.total || 0,
      });
    } catch (error) {
      console.error("Erro ao buscar cards:", error);
    } finally {
      setLoading(false);
    }
  };

  //  REAGE À TROCA DO HEADER
  useEffect(() => {
    //  Se ainda não carregou acessoAtivo,
    // já busca dados padrão (zera tela mas já renderiza)
    if (!acessoAtivo) {
      buscarCards({
        cnesIds: [],
        cpf: null,
        dataFimExame: null,
        dataInicioExame: null,
        nomePaciente: null,
      });
      return;
    }

    //  MODO TODOS
    if (acessoAtivo.idOrganograma === "TODOS") {
      setCidadeSelecionada("Todas as Unidades");
      setOrganogramaSelecionado(null);

      buscarCards({
        cnesIds: [],
        cpf: null,
        dataFimExame: null,
        dataInicioExame: null,
        nomePaciente: null,
      });

      return;
    }

    //  Unidade específica
    setCidadeSelecionada(acessoAtivo.descricao);
    setOrganogramaSelecionado(acessoAtivo.idOrganograma);

    buscarCards({
      idOrganograma: acessoAtivo.idOrganograma,
      cnesIds: [],
      cpf: null,
      dataFimExame: null,
      dataInicioExame: null,
      nomePaciente: null,
    });
  }, [acessoAtivo]);

  //  Clique vindo do mapa
  const handleCidadeClick = (cidade) => {
    const id = cidadeOrganogramaMap[cidade];
    if (!id) return;

    setCidadeSelecionada(cidade);
    setOrganogramaSelecionado(id);

    buscarCards({
      idOrganograma: id,
      cnesIds: [],
      cpf: null,
      dataFimExame: null,
      dataInicioExame: null,
      nomePaciente: null,
    });
  };

  return (
    <div
      className="page-wrapper d-flex flex-column"
      style={{ height: "100vh", overflow: "hidden" }}
    >
      <BotaoSuporte />

      {loading && (
        <div className="alert alert-info text-center m-2">
          Carregando dados...
        </div>
      )}

      <div className="container-fluid flex-fill d-flex flex-column p-3">
        <Graficos
          dadosCards={dadosCards}
          onCidadeClick={handleCidadeClick}
          cidadeSelecionada={cidadeSelecionada}
        />
      </div>
    </div>
  );
};

export default ChartsDashboard;
